export const routes = {
 HOME: '/',
 LOGIN: '/login',
 SIGNUP: '/signup',
 GROUPS: '/groups'
}